import React from 'react';
import CalibradorArte from '../shared/CalibradorArte';

export default function CalibrarInvitacion() {
  return <CalibradorArte tipo="invitacion" />;
}
